<template>
  <div class="group" @click.stop="openPopup">
    <!--TODO:事件到底是在捕获、目标还是冒泡阶段触发的？ 冒泡    -->
    <div class="left">
      <img :src="groupIcon" class="logo" alt="" />
      <span class="text">火爆交流群</span>
    </div>
    <div class="right">
      <img
        v-for="(avatar, index) in avatarList"
        :src="avatar"
        :key="index"
        class="avatar"
        alt=""
      />
      <img
        class="right-icon"
        src="../../../assets/icons/home/right@2x.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import { getGroups } from "@/api/group";
import groupIcon from "@/assets/icons/home/fire@2x.png";
import avatar_1 from "@/assets/icons/home/avatar_1@2x.png";
import avatar_2 from "@/assets/icons/home/avatar_2@2x.png";
import avatar_3 from "@/assets/icons/home/avatar_3@2x.png";
import avatar_4 from "@/assets/icons/home/avatar_4@2x.png";
import avatar_5 from "@/assets/icons/home/avatar_5@2x.png";
import avatar_6 from "@/assets/icons/home/avatar_6@2x.png";

const avatarList = [
  avatar_1,
  avatar_2,
  avatar_3,
  avatar_4,
  avatar_5,
  avatar_6
].reverse();
export default {
  name: "Group",
  data() {
    return {
      avatarList,
      groupIcon,
      groupUrl: ""
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const [group] = await getGroups();
      this.groupUrl = group.url;
    },
    openPopup() {
      window.open(this.groupUrl);
    }
  }
};
</script>
<style lang="scss" scoped>
.group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  background: rgba(250, 243, 254, 1);
  border-radius: 25px;
  text-align: left;
  .left {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .logo {
      margin: 0 10px 0 20px;
      width: 16px;
      height: 20px;
    }
    .text {
      font-size: 17px;
      font-weight: 500;
      color: rgba(163, 51, 231, 1);
    }
  }
  .right {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    .avatar {
      line-height: 50px;
      margin-right: -20px;
      width: 30px;
      height: 30px;
    }
    .right-icon {
      margin: 0 20px 0 30px;
      width: 10px;
      height: 16px;
    }
  }
}
</style>
